/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginBody
 */
export interface LoginBody {
    /**
     * 
     * @type {string}
     * @memberof LoginBody
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof LoginBody
     */
    password: string;
    /**
     * If a user is directed from another platform, they will have a signed url key. Logging in will automatically pull any missing information from the signed url and assign it to the user.
     * @type {string}
     * @memberof LoginBody
     */
    onboardingSignedUrlKey?: string;
}

/**
 * Check if a given object implements the LoginBody interface.
 */
export function instanceOfLoginBody(value: object): value is LoginBody {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function LoginBodyFromJSON(json: any): LoginBody {
    return LoginBodyFromJSONTyped(json, false);
}

export function LoginBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginBody {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'password': json['password'],
        'onboardingSignedUrlKey': json['onboardingSignedUrlKey'] == null ? undefined : json['onboardingSignedUrlKey'],
    };
}

export function LoginBodyToJSON(json: any): LoginBody {
    return LoginBodyToJSONTyped(json, false);
}

export function LoginBodyToJSONTyped(value?: LoginBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'password': value['password'],
        'onboardingSignedUrlKey': value['onboardingSignedUrlKey'],
    };
}

